export const dwellTimesTrackHeadTextFunc =
  'const first =  Object.fromEntries(trackHead.firstTimestampMicrosecondsEnteredZoneByZoneIdMap);\n\
const timesByZoneId = trackHead.lastTimestampMicrosecondsLeftZoneByZoneIdMap.map(([zoneID, ts]) => {\n\
  return `Zone ${zoneID}: ${(ts - first[zoneID])/1e6} seconds`\n\
});\n\
return timesByZoneId.join("\\n") + "\\n" + trackHead.cumulativeStoppedMicroseconds/1e6 + " seconds stopped in total";';

